import { ManagementApiUrl } from "environment/routeSettings";
import { netCall } from "utils/netCall";
import { TCity, TProvince } from "types/dto";
import { TRegion } from "contexts/regions_v2/types";
import { TResponseCode } from "utils/netCall/types";

export const storeRegionsDataKeyName = "Regions";

export const getAllProvinceWithChild = async () => {
  const res = await netCall<TProvince[]>({
    method: "GET",
    endPoint: `${ManagementApiUrl()}/api/Province/GetAllProvinceWithChilds`,
  });
  if (res.responseCode === TResponseCode.OK) {
    return res.results || [];
  } else {
    return undefined;
  }
};

export const getStoredRegionData = (): TRegion | undefined => {
  const storedData = localStorage.getItem(storeRegionsDataKeyName);
  if (!storedData) return undefined;
  return JSON.parse(storedData);
};
export const storeRegionData = (data: TRegion) => {
  localStorage.setItem(storeRegionsDataKeyName, JSON.stringify(data));
};
